import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';
import { Helmet } from 'react-helmet';


const Blog18 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_18;

    const {title, p} = InfoContent.Blog_18.one;
    const {title2, p2} = InfoContent.Blog_18.two;
    const {title3, p3} = InfoContent.Blog_18.three;
    const {title4, p4} = InfoContent.Blog_18.four;
    const {title5, p5} = InfoContent.Blog_18.five;
    const {title6, p6} = InfoContent.Blog_18.six;
    const {title7, p7} = InfoContent.Blog_18.seven;
    const {title8, p8} = InfoContent.Blog_18.eight;
    const {Ctitle, Cp} = InfoContent.Blog_18.conclusion;

    const {liss1} = ListContent.Blog_18.L1;
    const {liss2} = ListContent.Blog_18.L2;
    const {liss3} = ListContent.Blog_18.L3;
    const {liss4} = ListContent.Blog_18.L4;
  return (
    <>

        <Helmet>
            <title>
               IVF Centre in Mumbai | Best Fertility Clinic – Acme Fertility
            </title>

            <meta
                name="description"
                content="Find the best IVF centre in Mumbai at Acme Fertility offering advanced IVF, ICSI, IUI, fertility preservation, and personalized treatments with expert specialists and high success rates."
            />

            <meta
                name="keywords"
                content="IVF centre in Mumbai, IVF clinic Mumbai, best fertility clinic Mumbai, IVF treatment Mumbai, infertility treatment Mumbai, Acme Fertility, ICSI treatment Mumbai, IUI clinic Mumbai, egg freezing Mumbai, male infertility treatment Mumbai, fertility specialist Mumbai, IVF cost in Mumbai"
            />

            <link
                rel="canonical"
                href="https://www.acmefertility.com/18/BlogDetails"
            />

        <script type="application/ld+json">
                {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "MedicalClinic",
                "name": "Acme Fertility",
                "description": "Acme Fertility is a leading IVF centre in Mumbai offering advanced fertility treatments including IVF, ICSI, IUI, donor programs, fertility preservation, and personalized reproductive care.",
                "medicalSpecialty": "Fertility Clinic",
                "address": {
                "@type": "PostalAddress",
                "addressLocality": "Mumbai",
                "addressRegion": "Maharashtra",
                "addressCountry": "IN"
                },
                "areaServed": "Mumbai",
                "availableService": [
                "IVF Treatment",
                "ICSI",
                "IUI",
                "Egg Freezing",
                "Sperm Freezing",
                "Donor Programs",
                "Male Infertility Treatment",
                "Female Infertility Treatment"
                ],
                "brand": {
                "@type": "Brand",
                "name": "Acme Fertility"
                }
                })}
        </script>
        </Helmet>

        

    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                    <Info title={title} p={p} />
                    <Info title={title2} p={p2} />
                    {/* <List liss={liss1} /> */}
                    <Info title={title3} p={p3} />
                    <Info title={title4} p={p4} />
                    <Info title={title5} p={p5} />
                    <List liss={liss1} />
                    {/* <Info title={title5} p={p5} /> */}
                    <Info title={title6} p={p6} />
                    <List liss={liss2} />
                    <Info title={title7} p={p7} />
                   <div className="table-responsive mb-4">
                    <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Fertility Treatment</th>
                                    <th>Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>IVF (In Vitro Fertilization)</td>
                                    <td>₹1,00,000 to ₹2,00,000</td>
                                </tr>
                            </tbody>
                        </table>
                   </div>
                    
                    <div
                            style={{
                                backgroundColor: "#cfe8ff",
                                padding: "12px",
                                fontStyle: "italic",
                                marginBottom: "20px"
                            }}
                        >
                            Note: Final cost may vary depending on individual treatment plans and medical requirements.
                            A consultation is recommended for an accurate estimate.
                    </div>
                     <Info title={title8}/>
                     <List liss={liss3} />
                     <Info title={Ctitle} p={Cp} />

                    
             </div>

                <div className="col-lg-4">
                    <RecentBlogsList/>
                    <RightHandSide/>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default Blog18